// Module
var code = "<v5-frame frame-classes=\"iframe-modal\" class=\"quick-import-v5-frame\" src=\"$ctrl.src\" params=\"$ctrl.params\" on-message=\"$ctrl.onMessage($event)\"></v5-frame> ";
// Exports
export default code;